import React, { useEffect, useState } from 'react';
import { Phone } from 'lucide-react';
import { useLanguage } from './LanguageContext';
export function PhoneStrip() {
  const [visible, setVisible] = useState(false);
  const {
    t
  } = useLanguage();
  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 400);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <a href="tel:+13055550199" aria-label="Llamar ahora (1-305) 555-0199" className={`fixed bottom-0 left-0 w-full z-[999] bg-crimson hover:bg-crimson-glow py-3.5 px-10 flex justify-center items-center gap-5 transition-all duration-500 ease-in-out cursor-pointer group ${visible ? 'translate-y-0' : 'translate-y-full'}`} data-id="element-214">
      <span className="hidden sm:inline text-[11px] tracking-[3px] uppercase text-white font-medium" data-id="element-215">
        {t('phone.pre')}
      </span>
      <span className="inline-flex items-center gap-2.5 font-serif text-lg font-bold text-white group-hover:scale-105 transition-transform duration-300" data-id="element-216">
        <Phone className="w-4 h-4 animate-pulse" strokeWidth={2.5} fill="currentColor" data-id="element-217" />
        (1-305) 555-0199
      </span>
      <span className="hidden sm:inline text-[11px] tracking-[3px] uppercase text-white font-medium" data-id="element-218">
        {t('phone.post')}
      </span>
    </a>;
}